<template>
  <div class="raft-field-group">
    <accordion-form-fields
      v-if="groupType === 'accordion_item'"
      :id="groupId"
      :label="groupLabel"
      :class="groupConfig.format_settings.classes"
      :collapsed="groupConfig.collapsed"
    >
      <template #accordionFormFields>
        <slot />
      </template>
    </accordion-form-fields>

    <details-field-group
      v-else-if="groupType === 'details'"
      :id="groupId"
      :label="groupLabel"
      :collapsed="disabled"
      :required="required"
    >
      <template #content>
        <slot />
      </template>
    </details-field-group>

    <fieldset v-else-if="groupType === 'fieldset'">
      <legend>{{ groupLabel }}</legend>
      <slot />
    </fieldset>

    <component
      v-else-if="groupType === 'html_element'"
      :is="dynamicComponent"
      :tag="groupConfig.format_settings.element"
      :class-name="groupConfig.format_settings.classes"
      :id="groupConfig.format_settings.id"
    >
      <template v-if="showGroupLabel(groupConfig)">
        <component :is="groupConfig.format_settings.label_element">
          {{ groupLabel }}
        </component>
      </template>
      <slot />
    </component>
  </div>
</template>

<script>
import AccordionFormFields from "./AccordionFormFields.vue";
import DetailsFieldGroup from "./DetailsFieldGroup.vue";

export default {
  name: "FieldGroup",
  components: {
    DetailsFieldGroup,
    AccordionFormFields,
  },
  props: {
    groupId: { type: String, required: true },
    groupType: { type: String, required: true },
    groupLabel: { type: String, default: "" },
    groupConfig: { type: Object, required: false },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
  },
  computed: {
    dynamicComponent: function () {
      return {
        props: {
          tag: { type: String, default: "div" },
          className: { type: String, default: null },
          id: { type: String, default: null },
        },
        render(createElement) {
          return createElement(
            this.tag,
            {
              domProps: {
                id: this.id,
                class: this.className,
              },
            },
            this.$slots.default,
          );
        },
      };
    },
  },
  methods: {
    showGroupLabel({ format_settings: { label_element, show_label } }) {
      return label_element !== "" && show_label !== false;
    },
  },
};
</script>

<style scoped></style>
